export const ColorMode = {
  All: 0,
  Sw: 100,
  Color: 200
}
